import React, { useEffect, useRef } from 'react';
import { aboutParagraphs } from '../mock';
import { useLang } from '../i18n/LanguageContext';

export default function About() {
  const ref = useRef(null);
  const { t } = useLang();

  useEffect(() => {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach((e) => e.isIntersecting && e.target.classList.add('in-view'));
    }, { threshold: 0.15 });
    ref.current?.querySelectorAll('.reveal').forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  return (
    <section id="about" ref={ref} className="py-24 lg:py-32 bg-white">
      <div className="max-w-3xl mx-auto px-6 text-center">
        <p className="reveal text-[color:var(--brand)] uppercase tracking-[0.4em] text-xs mb-4">{t('about.eyebrow')}</p>
        <h2 className="reveal text-4xl md:text-5xl font-light text-[color:var(--ink)] mb-3" style={{ fontFamily: 'Playfair Display, serif' }}>
          {t('about.title')}
        </h2>
        <div className="reveal mx-auto w-16 h-[2px] bg-[color:var(--brand)] mb-10" />
        <div className="space-y-6 text-[color:var(--muted)] leading-relaxed text-[15px]">
          {aboutParagraphs.map((p, i) => (
            <p key={i} className="reveal">{p}</p>
          ))}
        </div>
      </div>
    </section>
  );
}
